module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4NCiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPg0KICAgICAgICA8ZyBzdHJva2U9IiNCMEI1QzEiIHN0cm9rZS13aWR0aD0iMyI+DQogICAgICAgICAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNTYyIC0zOSkgdHJhbnNsYXRlKDU2MiAzOSkiPg0KICAgICAgICAgICAgICAgIDxyZWN0IHdpZHRoPSIyMSIgaGVpZ2h0PSIyMSIgeD0iMS41IiB5PSIxLjUiIHJ4PSIxMC41Ii8+DQogICAgICAgICAgICA8L2c+DQogICAgICAgIDwvZz4NCiAgICA8L2c+DQo8L3N2Zz4NCg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/checkmark-status-icon-off.svg
// module id = 8va9
// module chunks = 1